import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {SupportCategoryModel, SupportCategoryRequest, SupportPostModel, SupportPostRequest} from '@services/back-office';
import {SupportCategoryCommonModel} from '@support/components/knowledge-base/category-tree/category-tree.component';

// categories

export const LoadPostsTree = createAction(
    '[Knowledge Base] Load Posts Tree'
);

export const LoadPostsTreeSuccess = createAction(
    '[Knowledge Base] Load Posts Tree Success',
    props<{ payload: { categories: SupportCategoryCommonModel[] } }>()
);

export const LoadPostsTreeFailure = createAction(
    '[Knowledge Base] Load Posts Tree Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const AddCategory = createAction(
    '[Knowledge Base] Add Category',
    props<{ payload: { request: SupportCategoryRequest, rootCategoryId: SupportCategoryRequest.TypeEnum, parentCategoryId?: string } }>()
);

export const AddCategorySuccess = createAction(
    '[Knowledge Base] Add Category Success',
    props<{ payload: { response: SupportCategoryCommonModel, rootCategoryId: SupportCategoryRequest.TypeEnum, parentCategoryId?: string } }>()
);

export const AddCategoryFailure = createAction(
    '[Knowledge Base] Add Category Failure',
    props<{ error: HttpErrorResponse }>()
);


export const EditCategory = createAction(
    '[Knowledge Base] Edit Category',
    props<{ payload: {request: SupportCategoryRequest, prevRootCategoryId: SupportCategoryRequest.TypeEnum, prevParentCategoryId?: string, rootCategoryId: SupportCategoryRequest.TypeEnum, parentCategoryId?: string} }>()
);

export const EditCategorySuccess = createAction(
    '[Knowledge Base] Edit Category Success',
    props<{ payload: { category: SupportCategoryCommonModel, prevRootCategoryId: SupportCategoryRequest.TypeEnum, prevParentCategoryId?: string, rootCategoryId: SupportCategoryRequest.TypeEnum, parentCategoryId?: string } }>()
);

export const EditCategoryFailure = createAction(
    '[Knowledge Base] Edit Category Failure',
    props<{ error: HttpErrorResponse }>()
);


export const DeleteCategory = createAction(
    '[Knowledge Base] Delete Category',
    props<{ categoryId: string }>()
);

export const DeleteCategorySuccess = createAction(
    '[Knowledge Base] Delete Category Success',
    props<{ categoryId: string }>()
);

export const DeleteCategoryFailure = createAction(
    '[Knowledge Base] Delete Category Failure',
    props<{ categoryId: string, error: HttpErrorResponse }>()
);


// posts

export const SearchPosts = createAction(
    '[Knowledge Base] Search Posts',
    props<{ payload: { query: string } }>()
);

export const SearchPostsSuccess = createAction(
    '[Knowledge Base] Search Posts Success',
    props<{ payload: { response: SupportPostModel[] } }>()
);

export const SearchPostsFailure = createAction(
    '[Knowledge Base] Search Posts Failure',
    props<{ error: HttpErrorResponse }>()
);


export const ClearSearchedPosts = createAction(
    '[Knowledge Base] Clear Searched Posts',
);


export const LoadPost = createAction(
    '[Knowledge Base] Load Post',
    props<{ payload: { id: string } }>()
);

export const LoadPostSuccess = createAction(
    '[Knowledge Base] Load Post Success',
    props<{ payload: { response: SupportPostModel } }>()
);

export const LoadPostFailure = createAction(
    '[Knowledge Base] Load Post Failure',
    props<{ error: HttpErrorResponse }>()
);


export const UpsertPost = createAction(
    '[Knowledge Base] Upsert Post',
    props<{ payload: { request: SupportPostRequest } }>()
);

export const UpsertPostSuccess = createAction(
    '[Knowledge Base] Upsert Post Success',
    props<{ payload: { response: SupportPostModel } }>()
);

export const UpsertPostFailure = createAction(
    '[Knowledge Base] Upsert Post Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const DeletePost = createAction(
    '[Knowledge Base] Delete Post',
    props<{ payload: { postId: string } }>()
);

export const DeletePostSuccess = createAction(
    '[Knowledge Base] Delete Post Success',
    props<{ payload: { postId: string } }>()
);

export const DeletePostFailure = createAction(
    '[Knowledge Base] Delete Post Failure',
    props<{ payload: { error: HttpErrorResponse, postId: string } }>()
);


// tree

export const TreeToggleNode = createAction(
    '[Knowledge Base] Toggle Node',
    props<{ nodeId: string }>()
);

export const TreeOpenNode = createAction(
    '[Knowledge Base] Tree Open',
    props<{ nodeId: string, expandNode?: boolean }>()
);

export const TreeToggleAllNodes = createAction(
    '[Knowledge Base] Toggle All Nodes',
);


export const ClosePost = createAction(
    '[Knowledge Base] Close Post'
);


export const ToggleCategoryArchived = createAction(
    '[Knowledge Base] Toggle Category Archived',
    props<{ payload: { categoryId: string } }>()
);

export const ToggleCategoryArchivedSuccess = createAction(
    '[Knowledge Base] Toggle Category Archived Success',
    props<{ payload: { response: SupportCategoryCommonModel } }>()
);

export const ToggleCategoryArchivedFailure = createAction(
    '[Knowledge Base] Toggle Category Archived Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const SetInitialState = createAction(
    '[Knowledge Base] Set Initial State'
);
